export default __webpack_public_path__ + "static/404-bg-ca2a08e5bade23d74d6d6f78e3947470.png";